import { Action } from '@ngrx/store';
import {MspPaymentSetting} from '../region.model';
import {Update} from '@ngrx/entity';

export enum MspRegionPaymentActionTypes {
  GetMspRegionPayment = '[MspRegion] Get Msp Regions Payment',
  GetMspRegionPaymentSuccess = '[MspRegion] Get Msp Regions Payment Success',
  GetMspRegionPaymentFail = '[MspRegion] Get Msp Regions Payment Fail',
  UpdateMspRegionPayment = '[MspRegion] Update Msp Region Payment',
  GetMspPaymentSettingByDistributor = '[MspRegion] Get Msp Distributor Regions Payment',
  GetMspPaymentSettingByDistributorSuccess = '[MspRegion] Get Msp Distributor Regions Payment Success',
  GetMspPaymentSettingByDistributorFail = '[MspRegion] Get Msp Distributor Regions Payment Fail',
  ReadMspPaymentDocumentList = '[MspRegion] Read Msp Payment Document List',
  ReadMspPaymentDocumentListSuccess = '[MspRegion] Read Msp Payment Document List Success',
  ReadMspPaymentDocumentListFail = '[MspRegion] Read Msp Payment Document List Fail',
  ReadMspPaymentDocument = '[MspRegion] Read Msp Payment Document',
  ReadMspPaymentDocumentSuccess = '[MspRegion] Read Msp Payment Document Success',
  ReadMspPaymentDocumentFail = '[MspRegion] Read Msp Payment Document Fail',
  UpdateMspPaymentDocument = '[MspRegion] Update Msp Payment Document',
  GenerateMspPaymentDocument = '[MspRegion] Generate Msp Payment Document',
  ReadMspDeviceUsageList = '[MspRegion] Read Msp Device Usage List',
  ReadMspDeviceUsageListSuccess = '[MspRegion] Read Msp Device Usage List Success',
  ReadMspDeviceUsageListFail = '[MspRegion] Read Msp Device Usage List Fail',
  ReadMspDeviceUsage = '[MspRegion] Read Msp Device Usage',
  ReadMspDeviceUsageSuccess = '[MspRegion] Read Msp Device Usage Success',
  ReadMspDeviceUsageFail = '[MspRegion] Read Msp Device Usage Fail',
}

// Get Msp Region Payment
export class GetMspRegionPayment implements Action {
  readonly type = MspRegionPaymentActionTypes.GetMspRegionPayment;
  constructor(public payload: any = null ) {}
}
export class GetMspRegionPaymentSuccess implements Action {
  readonly type = MspRegionPaymentActionTypes.GetMspRegionPaymentSuccess;
  constructor(public payload: any = null) {}
}
export class GetMspRegionPaymentFail implements Action {
  readonly type = MspRegionPaymentActionTypes.GetMspRegionPaymentFail;
  constructor(public payload: any = null ) {}
}

// Update Msp Region Payment
export class UpdateMspRegionPayment implements Action {
  readonly type = MspRegionPaymentActionTypes.UpdateMspRegionPayment;
  constructor(public payload: any = null ) {}
}

// Get Msp Distributor Region Payment
export class GetMspPaymentSettingByDistributor implements Action {
  readonly type = MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributor;
  constructor(public payload: any = null ) {}
}
export class GetMspPaymentSettingByDistributorSuccess implements Action {
  readonly type = MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributorSuccess;
  constructor(public payload: any = null) {}
}
export class GetMspPaymentSettingByDistributorFail implements Action {
  readonly type = MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributorFail;
  constructor(public payload: any = null ) {}
}

// Read Msp Payment Document List
export class ReadMspPaymentDocumentList implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspPaymentDocumentList;
  constructor(public payload: any = null ) {}
}

export class ReadMspPaymentDocumentListSuccess implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspPaymentDocumentListSuccess;
  constructor(public payload: any = null ) {}
}

export class ReadMspPaymentDocumentListFail implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspPaymentDocumentListFail;
  constructor(public payload: any = null ) {}
}

// Read Msp Payment Document
export class ReadMspPaymentDocument implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspPaymentDocument;
  constructor(public payload: any = null ) {}
}

export class ReadMspPaymentDocumentSuccess implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspPaymentDocumentSuccess;
  constructor(public payload: any = null ) {}
}

export class ReadMspPaymentDocumentFail implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspPaymentDocumentFail;
  constructor(public payload: any = null ) {}
}

// Update Msp Payment Document
export class UpdateMspPaymentDocument implements Action {
  readonly type = MspRegionPaymentActionTypes.UpdateMspPaymentDocument;
  constructor(public payload: any = null ) {}
}

// Generate Msp Payment Document
export class GenerateMspPaymentDocument implements Action {
  readonly type = MspRegionPaymentActionTypes.GenerateMspPaymentDocument;
  constructor(public payload: any = null ) {}
}

// Read Msp Device Usage List
export class ReadMspDeviceUsageList implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspDeviceUsageList;
  constructor(public payload: any = null ) {}
}

export class ReadMspDeviceUsageListSuccess implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspDeviceUsageListSuccess;
  constructor(public payload: any = null ) {}
}

export class ReadMspDeviceUsageListFail implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspDeviceUsageListFail;
  constructor(public payload: any = null ) {}
}

// Read Msp Device Usage
export class ReadMspDeviceUsage implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspDeviceUsage;
  constructor(public payload: any = null ) {}
}

export class ReadMspDeviceUsageSuccess implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspDeviceUsageSuccess;
  constructor(public payload: any = null ) {}
}

export class ReadMspDeviceUsageFail implements Action {
  readonly type = MspRegionPaymentActionTypes.ReadMspDeviceUsageFail;
  constructor(public payload: any = null ) {}
}


export type MspRegionPaymentActions = GetMspRegionPayment
  | GetMspRegionPaymentSuccess
  | GetMspRegionPaymentFail
  | GetMspPaymentSettingByDistributor
  | GetMspPaymentSettingByDistributorSuccess
  | GetMspPaymentSettingByDistributorFail
  | UpdateMspRegionPayment
  | ReadMspPaymentDocumentList
  | ReadMspPaymentDocumentListSuccess
  | ReadMspPaymentDocumentListFail
  | ReadMspPaymentDocument
  | ReadMspPaymentDocumentSuccess
  | ReadMspPaymentDocumentFail
  | UpdateMspPaymentDocument
  | GenerateMspPaymentDocument
  | ReadMspDeviceUsageList
  | ReadMspDeviceUsageListSuccess
  | ReadMspDeviceUsageListFail
  | ReadMspDeviceUsage
  | ReadMspDeviceUsageSuccess
  | ReadMspDeviceUsageFail;
